import { useTranslation } from 'react-i18next';
import React from 'react';
import { COLOR } from '@src/styles/color';
import { ArrowBackRounded as ArrowBackIcon } from '@mui/icons-material';
import CommonButton from '@src/new-components/Button';
import { useHistory } from 'react-router-dom';

const BackButton = ({ isPreviousEvent, onResetEvent }) => {
  const { t } = useTranslation();
  const history = useHistory();

  const handleGoBack = () => {
    if (isPreviousEvent) {
      onResetEvent();
    } else {
      history.goBack();
    }
  };

  return (
    <CommonButton
      variant="outlineSmall"
      customStyle={{
        borderRadius: '12px',
        height: '48px',
        padding: '12px',
      }}
      textProps={{
        variantText: 'body-16-semibold',
        color: COLOR.darkBlue,
        className: 'text-back-button',
      }}
      startIcon={
        <ArrowBackIcon sx={{ fontSize: '24px', color: COLOR.navyBlue }} />
      }
      onClick={handleGoBack}
    >
      {t('back')}
    </CommonButton>
  );
};

export default BackButton;
